import React, { useState, useEffect, useMemo, useRef } from "react";
import DashNav from "../../Components/DashNav/DashNav";
import InputField from "../../Components/InputField/InputField";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import Gbtn from "../../Components/buttons/Gbtn";
import NewsPaper from "../../Components/SVGS/NewsPaper";
import { FcDocument } from "react-icons/fc";
import Modal from "react-modal";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import { deleteNE, getAllCatageory, postNE, postSolutionData } from "../../api";
import { getImageUrl } from "../../helpers/getImageUrl";
import validator from "validator";
import { RxCross2 } from "react-icons/rx";
import RichTextarea from "../../Components/RichTextArea";
import { Document, Page, pdfjs } from "react-pdf";
import DocViewerComp from "../../Components/DocViewerComp/DocViewerComp";
import { componentsToColor } from "pdf-lib";
import { MdWbIridescent } from "react-icons/md";
import JoditEditor from "jodit-react";
import { FaRegCopy } from "react-icons/fa6";
import { GoCopy } from "react-icons/go";



export default function SolutionsAddEdit({ isEdit, isDelete }) {
    const icon = () => {
        return <MdWbIridescent size="26" height="30" fill="#DF2F35" />;
    };

    const location = useLocation();
    const prevData =
        location.state && location.state ? location.state.editData : "";
    const page = location.state && location.state ? location.state.page : null;


    let baseUrl = process.env.REACT_APP_BASE_URL;
    const editor = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isErr, setisErr] = useState(false);
    const [errMsg, seterrMsg] = useState("");
    const [profileImage, setProfileImage] = useState("");
    const [images, setImages] = useState(prevData ? prevData.solution_images : []);
    const [deletedimages, setDeletedImages] = useState([]);
    const [editImage, setEditImage] = useState("");
    const [imageErr, setImageErr] = useState(false);
    const [selectedCat, setSelectedCat] = useState("");
    const [titleErr, setTitleErr] = useState(false);
    const [shortDescriptionErr, setshortDescriptionErr] = useState(false);
    const [detDescriptionErr, setdetDescriptionErr] = useState(false);
    const [imageImputErr, setimageImputErr] = useState(false);
    const [catOpt, setcatOpt] = useState([]);
    const [authOptions, setAuthOptions] = useState([]);
    const [updatedData, setUpdatedData] = useState({
        id: prevData ? prevData.id : 0,
        name: prevData ? prevData.name : "",
        short_description: prevData ? prevData.short_description : "",
        detailed_description: prevData ? prevData.detailed_description : "",
        solution_images: prevData ? prevData.solution_images : [],
    });

    const navigate = useNavigate();

    const discardOnclick = () => {
        navigate("/dashboard/solutions", {
            state: { page: page },
        });
    };

    useEffect(() => {
        getAuthors();
        setEditImage(prevData ? prevData.image_path : "");
    }, []);

    useEffect(() => {
        Modal.setAppElement("#root");
    }, []);

    const getAuthors = () => {
        getAllCatageory(100, 1).then(({ data }) => {
            if (data.error_code === 0) setAuthOptions(data.result);
        });
    };

    useEffect(() => {
        setOptions();
    }, [authOptions]);

    const setOptions = () => {
        let arr = [];
        for (let index = 0; index < authOptions.length; index++) {
            const element = authOptions[index];
            let obj = { value: element.id, label: element.name };
            arr.push(obj);
            if (element.id === prevData.category_type) setSelectedCat(obj);
        }
        setcatOpt(arr);
    };

    const onSelectImage = (imgs) => {
        const files = Array.from(imgs);
        files.forEach(img => {
            if (
                img.type.includes("png") ||
                img.type.includes("jpg") ||
                img.type.includes("jpeg")
            ) {
                setImages((prev) => [...prev, img]);
                setImageErr(false);
                setEditImage("");
            } else {
                alert("Invalid File!");
            }
        })
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
        setUpdatedData({ ...updatedData, [name]: value });
    };


    const addOnclick = () => {
        if (!updatedData.name) setTitleErr(true)
        else {
            setimageImputErr(false);
            let data = new FormData();
            data.append("id", updatedData.id);
            data.append("name", updatedData.name);
            data.append("short_description", updatedData.short_description);
            data.append("detailed_description", updatedData.detailed_description);
            images.forEach((img, index) => {
                data.append(`solution_images[${index}].id`, img?.id ? img.id : 0);
                data.append(`solution_images[${index}].solution_id`, updatedData?.id ? updatedData.id : 0);
                if (img.image) data.append(`solution_images[${index}].image_path`, img?.image)
                else
                    data.append(`solution_images[${index}].image_file`, img);
            });
            deletedimages.forEach((id, index) => {
                data.append(`deleted_solution_images[${index}]`, id);
            });
            setisErr(false);
            setIsLoading(true);
            postSolutionData(data)
                .then(({ data }) => {
                    setIsLoading(false);
                    if (data.success || data.error_code == 0 || data.error_code == 1) {
                        navigate("/dashboard/solutions", {
                            state: { page: page },
                        });
                    } else {
                        setisErr(true);
                        seterrMsg(data.message);
                    }
                })
                .catch((err) => {
                    setIsLoading(false);
                    setisErr(true);
                    seterrMsg('Network Error.');
                    console.log("post sol axios err", err);
                });
        }
    };


    const handleImageErr = () => {
        setImageErr(true);
        setEditImage("");
        setProfileImage("");
    };

    function removeImage(index, image) {
        if (image.image) setDeletedImages(prev => [...prev, image.id]);
        let newArr = [...images];
        newArr.splice(index, 1);
        setImages(newArr);
    }

    return (
        <>

            <div className="mainDashView">
                <div>
                    <DashNav svg={icon} DashboardNavText={"Solutions"} />
                </div>
                <div className="dashPanel">
                    <div
                        style={{
                            display: isErr ? "flex" : "none",
                            color: "red",
                            justifyContent: "center",
                            position: "absolute",
                            width: "60%",
                        }}
                    >
                        Error! {errMsg}
                    </div>

                    <div className="ae-formArea">
                        {isLoading ? (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    width: "100%",
                                }}
                            >
                                <LoadingSpinner />
                            </div>
                        ) : (
                            <div className="ae-form">
                                <div className="ae-formFields">
                                    <div className="ae-inputField">
                                        <InputField
                                            cat="Title"
                                            name={"name"}
                                            isErr={titleErr}
                                            errorMsg="Required"
                                            value={updatedData ? updatedData.name : ""}
                                            onChange={(e) => {
                                                setTitleErr(false);
                                                handleChange(e);
                                            }}
                                            placeholder="Enter title"
                                        />
                                    </div>
                                    <div className="ae-inputField">
                                        <InputField
                                            cat="Short Description"
                                            name={"short_description"}
                                            isErr={shortDescriptionErr}
                                            errorMsg="Required"
                                            value={updatedData ? updatedData.short_description : ""}
                                            onChange={(e) => {
                                                setshortDescriptionErr(false);
                                                handleChange(e);
                                            }}
                                            placeholder="Enter short description"
                                        />
                                    </div>
                                </div>

                                {/* description  */}
                                {/* <div style={{ position: "relative", marginBottom: "14px" }}>
                                    <div
                                        className="ae-formFields"
                                        style={{
                                            width: "92%",
                                            marginTop: "3em",
                                            marginBottom: "0px",
                                        }}
                                    >
                                        <RichTextarea
                                            name={"Detailed Description"}
                                            isErr={detDescriptionErr}
                                            errorMsg="Field is required"
                                            value={
                                                updatedData ? updatedData.detailed_description : ""
                                            }
                                            onChange={(e) => {
                                                setdetDescriptionErr(false);
                                                setUpdatedData({
                                                    ...updatedData,
                                                    detailed_description: e,
                                                });
                                            }}
                                            placeholder="Detailed Description"
                                        />
                                    </div>
                                    <div
                                        className="err-txt"
                                        style={{
                                            display: detDescriptionErr ? "flex" : "none",
                                            position: "absolute",
                                            width: "150px",
                                        }}
                                    >
                                        Description is required
                                    </div>
                                </div> */}
                                <div style={{ margin: "50px 0", width: '90%' }}>

                                    <JoditEditor
                                        ref={editor}
                                        value={updatedData.detailed_description}
                                        onBlur={(newContent) => setUpdatedData({
                                            ...updatedData,
                                            detailed_description: newContent,
                                        })}
                                    />
                                </div>

                                {/* images  */}
                                <div className="files-inputs-container">
                                    <div className="file-input">
                                        <div>
                                            <div className="if-txt" style={{ marginTop: "40px" }}>
                                                Add Image
                                            </div>
                                            <div className="Add_Client_Image_container">
                                                <label className="changeimage-label">

                                                    <div className="AddimageBtn">
                                                        <span className="cam_Image_upload">+</span>
                                                        <div>
                                                            <input
                                                                type="file"
                                                                className="formuploadimage_input"
                                                                accept=".png, .jpg, .jpeg"
                                                                multiple
                                                                onChange={(e) =>
                                                                    onSelectImage(e.target.files)
                                                                }
                                                                onClick={(event) =>
                                                                    (event.currentTarget.value = null)
                                                                }
                                                            />
                                                        </div>

                                                    </div>

                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    {images?.map((image, index) => (
                                        <div className="image_container">

                                            <div className="Add_Client_Image_container news_image">
                                                <label className="changeimage-label">
                                                    <img
                                                        src={
                                                            image ? image?.image
                                                                ? getImageUrl(baseUrl, image?.image)
                                                                :
                                                                URL?.createObjectURL(image) :
                                                                ''
                                                        }
                                                        onError={handleImageErr}
                                                        alt="cp"
                                                        height="120px"
                                                        width="120px"
                                                        className="add-image-Style"
                                                    />

                                                </label>
                                                <div
                                                    className="images_cross"
                                                    onClick={() => removeImage(index, image)}
                                                >
                                                    <RxCross2 size={15} color="white" />
                                                </div>

                                            </div>
                                            {image?.image && <div
                                                className="images_link"
                                                onClick={() => { navigator.clipboard.writeText(getImageUrl(baseUrl, image.image)) }}
                                            >
                                                {getImageUrl(baseUrl, image.image).substring(0, 22)}
                                                <span className="images_link_copy"><GoCopy size={18} /></span>
                                            </div>}
                                        </div>

                                    ))
                                    }
                                </div>
                            </div>
                        )}

                        <div>
                            <div className="ev-btnAdd ev-btn">
                                <Gbtn
                                    text={isEdit ? "Update" : "Add"}
                                    func={addOnclick}
                                    disabled={isLoading}
                                    color={isLoading ? "#df2f35c4" : "#DF2F35"}
                                    radius="5px"
                                    width="160px"
                                />
                            </div>
                            <div className="ev-btnDel ev-btn">
                                <Gbtn
                                    func={discardOnclick}
                                    text={isDelete ? "Back" : "Discard"}
                                    color="#0061B1"
                                    radius="5px"
                                    width="160px"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}


